/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Upgrade_Plan_Modal_Plans_Initial_TitleInputs */

const es_components_upgrade_plan_modal_plans_initial_title = /** @type {(inputs: Components_Upgrade_Plan_Modal_Plans_Initial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicial`)
};

const en_components_upgrade_plan_modal_plans_initial_title = /** @type {(inputs: Components_Upgrade_Plan_Modal_Plans_Initial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Initial`)
};

/**
* | output |
* | --- |
* | "Initial" |
*
* @param {Components_Upgrade_Plan_Modal_Plans_Initial_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_upgrade_plan_modal_plans_initial_title = /** @type {((inputs?: Components_Upgrade_Plan_Modal_Plans_Initial_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Upgrade_Plan_Modal_Plans_Initial_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_upgrade_plan_modal_plans_initial_title(inputs)
	return en_components_upgrade_plan_modal_plans_initial_title(inputs)
});
export { components_upgrade_plan_modal_plans_initial_title as "components.upgrade_plan_modal.plans.initial.title" }